import React from 'react';

import { Grid } from '@gogame/components';

export const DeepLinkSection = ({
  rewardPackage,
  location,
  subLocation,
  endDate,
  targetUsers,
  multipleRedemptions,
  maxRedemptions,
  audiences,
}) => {
  return (
    <Grid container item xs={12} spacing={3}>
      <Grid item xs={4}>
        {rewardPackage}
      </Grid>
      <Grid item xs={4}>
        {multipleRedemptions}
      </Grid>
      <Grid item xs={4} />
      {maxRedemptions ? (
        <React.Fragment>
          <Grid item xs={4}>
            {maxRedemptions}
          </Grid>
          <Grid item xs={8} />
        </React.Fragment>
      ) : null}
      <Grid item xs={4}>
        {location}
      </Grid>
      <Grid item xs={4}>
        {subLocation}
      </Grid>
      <Grid item xs={4}></Grid>
      <Grid item xs={4}>
        {endDate}
      </Grid>
      <Grid item xs={4}>
        {targetUsers}
      </Grid>
      <Grid item xs={4}>
        {audiences}
      </Grid>
    </Grid>
  );
};
